<template>
  <div class="content">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20 ftb">
      <el-breadcrumb-item>换电订单</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <h3 class="h3 mb20">用户信息</h3>
    <el-table
      border
      class="mb20"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="name" label="卡号"></el-table-column>
      <el-table-column prop="date" label="姓名"></el-table-column>
      <el-table-column prop="date" label="联系方式"></el-table-column>
    </el-table>
    <h3 class="h3 mb20">商品信息</h3>
    <el-table
      border
      class="mb20"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="name" label="服务类型"></el-table-column>
      <el-table-column prop="date" label="设备地址"></el-table-column>
      <el-table-column prop="date" label="换电柜编号"></el-table-column>
      <el-table-column prop="date" label="换电柜名称">
        <template slot-scope="{row}">

        </template>
      </el-table-column>
      <el-table-column prop="date" label="换入换出电池通讯板号"></el-table-column>
    </el-table>
    <h3 class="h3 mb20">选择套餐</h3>
    <el-table
      border
      class="mb20"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="name" label="换入换出柜门"></el-table-column>
      <el-table-column prop="date" label="换入换出电量"></el-table-column>
      <el-table-column prop="date" label="换电费"></el-table-column>
      <el-table-column prop="date" label="优惠"></el-table-column>
      <el-table-column prop="date" label="总额"></el-table-column>
    </el-table>
    <h3 class="h3 mb20">订单信息</h3>
    <el-table
      class="mb20"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column prop="name" label="订单状态"></el-table-column>
      <el-table-column prop="date" label="订单编号"></el-table-column>
      <el-table-column prop="date" label="下单时间"></el-table-column>
      <el-table-column prop="date" label="付款时间"></el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          name: 111
        }
      ]
    }
  },
  methods: {},
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/voucherMgmt.vue